import { render, staticRenderFns } from "./YouhuiPop.vue?vue&type=template&id=1bb31450&scoped=true"
import script from "./YouhuiPop.vue?vue&type=script&lang=js"
export * from "./YouhuiPop.vue?vue&type=script&lang=js"
import style0 from "./YouhuiPop.vue?vue&type=style&index=0&id=1bb31450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb31450",
  null
  
)

export default component.exports